import { Dispatch, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { refreshPayments } from '../../lib/store/common-actions';
import { setBankAccountDetailsOnCreate } from '../../lib/store/crm';

import Button from '../../shared_components/Button/Button';

import styles from './Modal.module.scss';

type Props = {
  textInfoModal: { title: string, description1: string, description2?: string },
  handleContinue: () => void;
} & ReduxProps;

const AddBankAccountModal = (props: Props) => {
  const {
    textInfoModal,
    callsForRefresh,
    refreshPaymentsData,
    handleContinue,
  } = props;

  const { title, description1, description2 } = textInfoModal;

  useEffect(() => {
    if (callsForRefresh) {
      refreshPaymentsData();
    }
  }, [callsForRefresh, refreshPaymentsData]);

  return (
    <>
      <div className={styles.textContainer}>
        <div id="bankDetailsSetTtile" className={styles.title}>{title}</div>
        <div>
          <span id="bankDetailsSetDescription1" className={styles.description}>{description1}</span>
          <span id="bankDetailsSetDescription2" className={styles.description}>{description2}</span>
        </div>
      </div>
      <Button
        id="bankDetailsSetContinue"
        fullWidth
        className={styles.btnContinue}
        biggerFontSize
        onClick={handleContinue}
      >
        {lang.commonContinueButton()}
      </Button>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  callsForRefresh: state.payment.callsForRefresh,
  hasDeposit: state.payment.hasDeposit,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  setBankAccountValuesOnCreate: () => dispatch(setBankAccountDetailsOnCreate({})),
  refreshPaymentsData: () => dispatch(refreshPayments()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(AddBankAccountModal);
